import { createAction, props } from '@ngrx/store';

const ID = '[OIDC] ';

export const configLoaded = createAction(`${ID}OIDC Configuration loaded`);
export const checkAuth = createAction(`${ID}Check authentication`);
export const authorize = createAction(`${ID}Authorize`);
export const authorizationSucceeded = createAction(
  `${ID}Authorization succeeded`
);
export const userDataReceived = createAction(
  `${ID}User data received`,
  props<any>()
);
export const logInByGuid = createAction(
  `${ID}Login by guid`,
  props<{ guid: string; language: string }>()
);
